import { render, staticRenderFns } from "./VaColorPickerInput.demo.vue?vue&type=template&id=1dd33350&"
import script from "./VaColorPickerInput.demo.vue?vue&type=script&lang=js&"
export * from "./VaColorPickerInput.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports